import { useEffect, useState } from "react";
import "../assets/css/researcher.css";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Card = ({ index, item, handleYearSelect }) => {
    return (
        <article
            className="card"
            data-aos="fade-up"
            data-aos-duration="300"
            data-aos-delay={index * 200}
            data-aos-once="true"
            // data-aos-anchor-placement="#budgetDetail"
        >
            <img
                src={item.budget_image}
                alt="research budget"
                className="budgetcover"
            />
            <div className="card-content">
                <div style={{ marginBottom: "auto", width: "100%" }}>
                    <p className="budget-year">ปีงบประมาณ {item.budget_year}</p>
                    <p className="amount">
                        ทุนวิจัย {item.budget_amount.toLocaleString()} บาท
                    </p>
                    <p className="source">แหล่งทุน: {item.budget_source}</p>
                </div>

                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        gap: "10px",
                        marginTop: "20px",
                    }}
                >
                    {item.researches?.length && (
                        <Link
                            to={`/researchbudget/${item.budget_year}`}
                            onClick={() =>
                                handleYearSelect &&
                                handleYearSelect(item.budget_year)
                            }
                            className="btn"
                        >
                            รายละเอียดทุนวิจัย
                        </Link>
                    )}
                </div>
            </div>
        </article>
    );
};

export default function ResearchBudget() {
    const { year_params } = useParams();
    const [researchBudgets, setResearchBudgets] = useState(null);
    const [selectedBudget, setSelectedBudget] = useState(null);
    const [resFiltered, setResFiltered] = useState(null);
    const [selectedYear, setSelectedYear] = useState(year_params || null);

    if (!researchBudgets) {
        axios
            .get("https://arch.mju.ac.th/json/research/researchbudget.json")
            .then((res) => {
                res.data = res.data.sort((a, b) => b.year - a.year);
                setResearchBudgets(res.data);
                console.log("Fetched research budgets:", res.data);
            })
            .catch((err) => {
                console.error("Error fetching research budgets:", err);
            });
        // setResearchers
    }

    if (researchBudgets && !resFiltered) {
        setResFiltered(researchBudgets);
    }

    useEffect(() => {
        AOS.init();
    }, []);

    useEffect(() => {
        console.log("year_params:", year_params);
        console.log("Selected year from params:", selectedYear);
        if (selectedYear && researchBudgets) {
            const res = researchBudgets.filter(
                (item) => parseInt(item.budget_year) === parseInt(selectedYear),
            )[0];
            // console.log("Filtered researchBudgets", researchBudgets, ":");
            // console.log("Selected budget for year", selectedYear, ":", res);
            setSelectedBudget(res);
        }
    }, [year_params, selectedYear, researchBudgets]);

    const handleYearSelect = (year) => {
        if (!year) {
            // setSelectedYear(null);
            return;
        }
        setSelectedYear(year);
        window.location.replace(`/researchbudget/${year}`);
    };

    return (
        <div
            style={{
                background: "#f8f4ef",
                color: "#2a1a0d",
                lineHeight: "1.6",
            }}
        >
            <div id="header">
                <div className="container">
                    <p className="page-website">arch.mju.ac.th</p>
                    <p className="page-title">ทุนวิจัยภายใน</p>
                    <p className="page-subtitle">
                        คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม
                        มหาวิทยาลัยแม่โจ้
                    </p>
                </div>
            </div>

            {researchBudgets?.length && (
                <main style={{ padding: "60px 0" }}>
                    <div className="container">
                        <div className="page-subheader">
                            <div>
                                <div className="page-title">
                                    Internal Researches
                                </div>
                                <p className="page-description">
                                    ค้นหาและติดตามทุนวิจัยภายในของคณะฯ
                                </p>
                            </div>

                            {/* <div id="search-box">
                                <input
                                    disabled={true}
                                    type="text"
                                    placeholder="ค้นหาทุนวิจัยภายใน..."
                                    onChange={handleFilter}
                                />
                            </div> */}
                        </div>

                        {selectedYear && selectedBudget && (
                            <section
                                id="budgetDetail"
                                className="budgetDetail"
                                style={{ display: "hidden" }}
                            >
                                <div
                                    style={{
                                        fontSize: "24px",
                                        textAlign: "center",
                                    }}
                                >
                                    ปีงบประมาณ: {selectedYear}
                                </div>
                                <div>
                                    ทุนวิจัยรวม:{" "}
                                    {selectedBudget.budget_amount.toLocaleString()}{" "}
                                    บาท
                                </div>
                                <div>
                                    รายละเอียด:
                                    <br />
                                    {selectedBudget.budget_detail}
                                </div>
                                {selectedBudget?.researches?.map(
                                    (res, index) => (
                                        <div
                                            key={index}
                                            className="box_research"
                                            data-aos="fade-left"
                                            data-aos-duration="300"
                                            data-aos-delay={index * 200}
                                            data-aos-once="true"
                                            data-aos-anchor-placement="#budgetDetail"
                                        >
                                            <div>
                                                mju code: {res.research_code}
                                            </div>
                                            <div>
                                                เรื่อง:{" "}
                                                {res.research_url ? (
                                                    <a
                                                        href={res.research_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {res.research_name}
                                                    </a>
                                                ) : (
                                                    <span>
                                                        {res.research_name}
                                                    </span>
                                                )}
                                            </div>
                                            <div>
                                                คำสำคัญ: {res.research_keyword}
                                            </div>
                                            <div>
                                                ทุนวิจัย:{" "}
                                                {res.research_amount.toLocaleString()}{" "}
                                                บาท
                                            </div>
                                            <div>
                                                สถานะ: {res.research_status}
                                            </div>
                                        </div>
                                    ),
                                )}
                            </section>
                        )}

                        <section className="cards">
                            {resFiltered?.map((item, index) => (
                                <Card
                                    key={index}
                                    index={index}
                                    item={item}
                                    handleYearSelect={handleYearSelect}
                                />
                            ))}
                        </section>
                    </div>
                </main>
            )}
        </div>
    );
}

export function ResearchBudgetCards() {
    const [researchBudgets, setResearchBudgets] = useState(null);

    if (!researchBudgets) {
        axios
            .get("https://arch.mju.ac.th/json/research/researchbudget.json")
            .then((res) => {
                res.data = res.data.sort((a, b) => b.year - a.year);
                setResearchBudgets(res.data);
                console.log("Fetched research budgets:", res.data);
            })
            .catch((err) => {
                console.error("Error fetching research budgets:", err);
            });
        // setResearchers
    }

    return (
        <div>
            <h2
                style={{
                    textAlign: "center",
                    marginTop: "40px",
                    marginBottom: "20px",
                }}
            >
                ทุนวิจัยภายในคณะฯ
            </h2>
            <section className="cards">
                {researchBudgets?.map((item, index) => (
                    <Card index={index} key={index} item={item} />
                ))}
            </section>
        </div>
    );
}
